import { render, staticRenderFns } from "./PlanoAdicionais.vue?vue&type=template&id=9fd77d04"
import script from "./PlanoAdicionais.vue?vue&type=script&lang=js"
export * from "./PlanoAdicionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports